import { render, staticRenderFns } from "./Buffalo.vue?vue&type=template&id=15b20079&scoped=true"
import script from "./Buffalo.vue?vue&type=script&lang=js"
export * from "./Buffalo.vue?vue&type=script&lang=js"
import style0 from "./Buffalo.vue?vue&type=style&index=0&id=15b20079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b20079",
  null
  
)

export default component.exports